import { sendPlausibleEvent } from "./plausibleHelpers";

const setupOfflineAnalytics = (swContainer) => {
  let wentOffline = false;

  swContainer.addEventListener("message", ({ data }) => {
    if (data?.type === "OFFLINE") {
      wentOffline = true;
    } else if (data?.type === "ONLINE" && wentOffline) {
      wentOffline = false;
      sendPlausibleEvent("Editor used offline");
    }
  });
};

export default setupOfflineAnalytics;
